<script setup>
import CompetitorKeywordStats from "@/components/competition/partials/keywords/KeywordStats.vue";
import CompetitorKeywordSearch from "@/components/competition/partials/keywords/KeywordSearch.vue";
import CompetitorKeywordsTable from "@/components/competition/partials/keywords/KeywordsTable.vue";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import {useStore} from "vuex";
import {computed} from "vue";

const store = useStore();

const rankingKeywordsRan = computed(() => store.getters['competitionV2/rankingKeywordsRan']);
</script>

<template>
  <div>
    <LoadingBlock v-if="!rankingKeywordsRan">
      Waiting for ranking keywords data
    </LoadingBlock>
    <div v-else>
      <CompetitorKeywordStats class="tw-px-8 tw-pt-4 tw-pb-8 tw-border-b" />
      <CompetitorKeywordSearch class="tw-px-8 tw-py-8" />
      <CompetitorKeywordsTable class="tw-px-8" />
    </div>
  </div>
</template>
